import Vue from 'vue'
import VueRouter from 'vue-router'
import vuetify from '@/plugins/vuetify'
import colors from '@/plugins/colors'
import store from '@/store/store'
// TEMPLATE GLOBAL
import Template from '@/views/Template'
import Signature from '@/views/Signature'

// WEB
import LandingPage from '@/views/web/landingpage/LandingPage'
import LoginConselho from '@/views/web/login/HomeCouncil'
import ChooseEntity from '@/views/web/login/ChooseEntity'

import Forgot from '@/views/web/login/Forgot'
import Start from '@/views/web/Start'

import ListDonations from '@/views/web/donations/List'
import NewDonations from '@/views/web/donations/New'
import Profile from '@/views/web/agent/Profile'

import InactiveCouncil from '@/views/web/Inactive'

// APP
import Login from '@/views/app/login/Login'

// APP > MANAGEMENT
import UserManagement from '@/views/app/management/User'
import SecretarysManagement from '@/views/app/management/Secretarys'
// import FundsManagement from '@/views/app/management/Funds'
import InstitutionManagement from '@/views/app/management/Institution'
import CouncilManagement from '@/views/app/management/Council'
import AgentsManagement from '@/views/app/management/Agents'

//APP > REGISTER
import UserRegister from '@/views/app/register/UserRegister'
import SecretarysRegister from '@/views/app/register/SecretarysRegister'
// import FundsRegister from '@/views/app/register/FundsRegister'
import InstitutionRegister from '@/views/app/register/InstitutionRegister'
import CouncilRegister from '@/views/app/register/CouncilRegister'

//APP > CONFIG
import CouncilConfig from '@/views/app/configurations/CouncilConfig'

//APP > DASHBOARD
import Dashboard from '@/views/app/dashboard/Dashboard'

//APP > FINANCE
import Finance from '@/views/app/finance/Finance'

//APP > RECEIPTS
import Receipts from '@/views/app/receipts/Receipts'

// ROUTES
import Routes from '@/router/names.js'

// SERVICES
import EntityService from '@/scripts/services/entity.service'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        ///// NÃO FAZEM PARTE DO SISTEMA
        {
            path: '/template',
            name: 'template',
            component: Template,
        },
        {
            path: '/signature/:id',
            name: 'signature',
            component: Signature,
        },
        {
            path: '/institucional',
            name: Routes.web.LandingPage,
            component: LandingPage,
        },
        ///// SITE CONSELHO UTILIZADO PELOS AGENTES
        {
            path: '/conselho/inativo',
            name: Routes.web.CouncilNotActive,
            component: InactiveCouncil,
            meta: {
                isCouncilUrl: true,
            },
        },
        {
            path: '/conselho/:councilId',
            component: LoginConselho,
            name: Routes.web.LoginCouncil,
            meta: {
                isCouncilUrl: true,
            },
        },
        {
            path: '/conselho/:councilId/inicio',
            component: Start,
            name: Routes.web.Start,
            meta: {
                name: 'Início',
                isCouncilUrl: true,
            },
        },
        {
            path: '/conselho/:councilId/doacoes/nova/:paymentMethod?',
            name: Routes.web.NewDonations,
            component: NewDonations,
            meta: {
                name: 'Novas doações',
                nav: [Routes.web.Start, Routes.web.ListDonations],
                isCouncilUrl: true,
            },
        },
        {
            path: '/conselho/:councilId/recuperacao-senha',
            name: Routes.web.Forgot,
            component: Forgot,
            meta: {
                isCouncilUrl: true,
            },
        },
        {
            path: '/conselho/:councilId/doacoes',
            name: Routes.web.ListDonations,
            component: ListDonations,
            meta: {
                name: 'Lista doações',
                nav: [],
                isCouncilUrl: true,
            },
        },
        {
            path: '/conselho/:councilId/perfil',
            name: Routes.web.Profile,
            component: Profile,
            meta: {
                name: 'Perfil',
                nav: [Routes.web.Start],
                isCouncilUrl: true,
            },
        },
        ///// SITE BENFEITORES - BACKOFFICE
        {
            path: '/login',
            name: Routes.web.Login,
            component: Login,
        },
        {
            path: '/choose/entity',
            name: Routes.web.ChooseEntity,
            component: ChooseEntity,
        },
        {
            path: '/perfil',
            name: Routes.web.UserProfile,
            component: Profile,
            meta: {
                name: 'Perfil Usuário',
                nav: [Routes.app.Dashboard],
                isCouncilUrl: false,
            },
        },
        {
            path: '/agente/:agentId',
            name: Routes.web.AgentProfile,
            component: Profile,
            meta: {
                name: 'Perfil Agente',
                nav: [Routes.app.Dashboard],
                isCouncilUrl: false,
            },
        },
        {
            path: '/recuperacao-senha',
            name: Routes.app.Forgot,
            component: Forgot,
            meta: {
                isCouncilUrl: false,
            },
        },
        /// DASHBOARD
        {
            path: '/',
            name: Routes.app.Dashboard,
            component: Dashboard,
            meta: {
                name: 'Início',
                nav: [],
                isCouncilUrl: false,
            },
        },
        /// FINANCEIRO
        {
            path: '/financeiro',
            name: Routes.app.Finance,
            component: Finance,
            meta: {
                name: 'Financeiro',
                nav: [Routes.app.Dashboard],
                isCouncilUrl: false,
            },
        },
        /// RECIBOS
        {
            path: '/recibos',
            name: Routes.app.Receipts,
            component: Receipts,
            isCouncilUrl: false,
        },
        /// USUÁRIOS
        {
            path: '/usuarios/:userId',
            name: Routes.app.UserRegister,
            component: UserRegister,
            meta: {
                name: 'Cadastro de usuário',
                nav: [Routes.app.Dashboard, Routes.app.UserManagement],
                isCouncilUrl: false,
            },
        },
        {
            path: '/usuarios/novo',
            name: Routes.app.UserRegisterNew,
            component: UserRegister,
            meta: {
                name: 'Edição de usuário',
                nav: [Routes.app.Dashboard, Routes.app.UserManagement],
                isCouncilUrl: false,
            },
        },
        {
            path: '/usuarios',
            name: Routes.app.UserManagement,
            component: UserManagement,
            meta: {
                name: 'Gestão de usuários',
                nav: [Routes.app.Dashboard],
                isCouncilUrl: false,
            },
        },
        /// SECRETARIAS
        {
            path: '/secretarias/:secretaryId',
            name: Routes.app.SecretarysRegister,
            component: SecretarysRegister,
            props: true,
            meta: {
                name: 'Edição de secretaria',
                nav: [Routes.app.Dashboard, Routes.app.SecretarysManagement],
                isCouncilUrl: false,
            },
        },
        {
            path: '/secretarias/nova',
            name: Routes.app.SecretarysRegisterNew,
            component: SecretarysRegister,
            props: true,
            meta: {
                name: 'Cadastro de secretaria',
                nav: [Routes.app.Dashboard, Routes.app.SecretarysManagement],
                isCouncilUrl: false,
            },
        },
        {
            path: '/secretarias',
            name: Routes.app.SecretarysManagement,
            component: SecretarysManagement,
            meta: {
                name: 'Gestão de secretarias',
                nav: [Routes.app.Dashboard],
                isCouncilUrl: false,
            },
        },
        /// FUNDOS
        // {
        //     path: '/fundos/:fundId',
        //     name: Routes.app.FundsRegister,
        //     component: FundsRegister,
        //     props: true,
        //     meta: {
        //         name: 'Edição de fundo',
        //         nav: [Routes.app.Dashboard, Routes.app.FundsManagement],
        //         isCouncilUrl: false,
        //     },
        // },
        // {
        //     path: '/fundos/novo',
        //     name: Routes.app.FundsRegisterNew,
        //     component: FundsRegister,
        //     props: true,
        //     meta: {
        //         name: 'Cadastro de fundo',
        //         nav: [Routes.app.Dashboard, Routes.app.FundsManagement],
        //         isCouncilUrl: false,
        //     },
        // },
        // {
        //     path: '/fundos',
        //     name: Routes.app.FundsManagement,
        //     component: FundsManagement,
        //     meta: {
        //         name: 'Gestão de fundos',
        //         nav: [Routes.app.Dashboard],
        //         isCouncilUrl: false,
        //     },
        // },
        /// INSTITUIÇÕES
        {
            path: '/instituicoes/:institutionId',
            name: Routes.app.InstitutionRegister,
            component: InstitutionRegister,
            props: true,
            meta: {
                name: 'Edição de instituição',
                nav: [Routes.app.Dashboard, Routes.app.InstitutionManagement],
                isCouncilUrl: false,
            },
        },
        {
            path: '/instituicoes/nova',
            name: Routes.app.InstitutionRegisterNew,
            component: InstitutionRegister,
            props: true,
            meta: {
                name: 'Cadastro de instituição',
                nav: [Routes.app.Dashboard, Routes.app.InstitutionManagement],
                isCouncilUrl: false,
            },
        },
        {
            path: '/instituicoes',
            name: Routes.app.InstitutionManagement,
            component: InstitutionManagement,
            meta: {
                name: 'Gestão de instituição',
                nav: [Routes.app.Dashboard],
                isCouncilUrl: false,
            },
        },
        /// CONSELHOS
        {
            path: '/conselhos/:councilId',
            name: Routes.app.CouncilRegister,
            component: CouncilRegister,
            meta: {
                name: 'Edição de conselho',
                nav: [Routes.app.Dashboard, Routes.app.CouncilManagement],
                isCouncilUrl: false,
            },
        },
        {
            path: '/conselhos/novo',
            name: Routes.app.CouncilRegisterNew,
            component: CouncilRegister,
            meta: {
                name: 'Cadastro de conselho',
                nav: [Routes.app.Dashboard, Routes.app.CouncilManagement],
                isCouncilUrl: false,
            },
        },
        {
            path: '/conselhos',
            name: Routes.app.CouncilManagement,
            component: CouncilManagement,
            meta: {
                name: 'Gestão de conselhos',
                nav: [Routes.app.Dashboard],
                isCouncilUrl: false,
            },
        },
        {
            path: '/conselhos/:councilId/configuracoes',
            name: Routes.app.CouncilConfig,
            component: CouncilConfig,
            meta: {
                name: 'Configurações de conselho',
                nav: [Routes.app.Dashboard, Routes.app.CouncilManagement],
                isCouncilUrl: false,
            },
        },
        /// AGENTES
        {
            path: '/agentes',
            name: Routes.app.AgentsManagement,
            component: AgentsManagement,
            meta: {
                name: 'Gestão de agentes',
                nav: [Routes.app.Dashboard],
                isCouncilUrl: false,
            },
        },
    ],
})

router.beforeEach((to, from, next) => {
    //TODO verificar se o usuário/agente tem permissão para acessar a página
    // if(to.meta && to.meta.isCouncilUrl && ) {

    // }
    
    // const currentHref = window.location.href;
    // if(!currentHref.includes('/conselho/') && !currentHref.includes(process.env.VUE_APP_FRONT_END_URL)) {
    //     const entityService = new EntityService()
    //         entityService
    //             .getCouncilIdByUrl(currentHref)
    //             .then((result) => {
    //                 if(result) {
    //                     console.log(result);
    //                 }});
    // }
    if(!!to.params && !!to.params.councilId)
        store.dispatch(
            'setCouncilId',
            to.params.councilId
        )
    else
        store.dispatch(
            'setCouncilId',
            null
        )
    if (
        !!to.params &&
        !!to.params.councilId &&
        to.meta &&
        to.meta.isCouncilUrl &&
        to.name != Routes.web.CouncilNotActive
    ) {
        if (!from.params || !from.params.councilId) {
            const entityService = new EntityService()
            entityService
                .getCouncilConfig(to.params.councilId)
                .then((result) => {
                    if (result && result.published && result.active) {
                        if (
                            result &&
                            result.primaryColor &&
                            result.secondaryColor
                        ) {
                            vuetify.framework.theme.themes.light.primary = result.primaryColor.substr(
                                0,
                                7
                            )
                            vuetify.framework.theme.themes.light.secondary = result.secondaryColor.substr(
                                0,
                                7
                            )
                        } else {
                            vuetify.framework.theme.themes.light.primary =
                                colors.primary
                            vuetify.framework.theme.themes.light.secondary =
                                colors.secondary
                        }
                        let root = document.documentElement;
                        root.style.setProperty('--primary', vuetify.framework.theme.themes.light.primary);
                        root.style.setProperty('--secondary', vuetify.framework.theme.themes.light.secondary);
                        if (result.faviconImage) {
                            var link = document.querySelector(
                                "link[rel*='icon']"
                            )
                            if (link) {
                                link.type = 'image/x-icon'
                                link.rel = 'shortcut icon'
                                link.href = result.faviconImage.url
                            }
                        }
                        if (result.lighLogo)
                            store.dispatch(
                                'setCouncilImage',
                                result.lighLogo.url
                            )
                        if (result.backgroundImage)
                            store.dispatch('setCouncilBackgroundImage', result.backgroundImage.url)
                        next()
                    } else {
                        router.push({ name: Routes.web.CouncilNotActive })
                    }
                })
        } else {
            next()
        }
    } else {
        vuetify.framework.theme.themes.light.primary = colors.primary
        vuetify.framework.theme.themes.light.secondary = colors.secondary
        next()
    }
})

export default router
